import { AppState, Platform } from 'react-native';
import { displayNotification } from './notification';
import { INotificationData } from './notificationData';
import { displayNotificationWithTimer } from './notification.native';

const parseNotifeeData = (notifeeString: string, appLanguage: string) => {
  const notifeeData = JSON.parse(notifeeString);
  if (notifeeData?.data?.i18n) {
    const localized = notifeeData.data.i18n[appLanguage!] ?? notifeeData;
    notifeeData.title = localized.title;
    notifeeData.body = localized.body;
  }
  return notifeeData;
};

export const onMessageReceived = async (message: any, appLanguage: string) => {
  const isDataNotification = message?.data && 'notifee' in message.data;
  if (isDataNotification) {
    const notifeeData = parseNotifeeData(message.data.notifee, appLanguage);
    const {
      title: notificationTitle,
      body: notificationBody,
      data: {
        campaignId,
        path: deeplinkingUrl,
        sourceReferenceId,
        sourceReferenceType,
        showTimer,
        startTime,
        endTime,
      },
      android,
      messageId,
    } = notifeeData;

    const imageUrl = android?.imageUrl;
    const data: INotificationData = {
      campaignId,
      deeplinkingUrl,
      sourceReferenceId,
      sourceReferenceType,
      showTimer,
      startTime,
      endTime,
      messageId: message?.messageId,
    };

    const displayPayload = {
      title: notificationTitle,
      body: notificationBody,
      imageUrl,
      data,
    };

    if (showTimer === 'true') {
      if (Platform.OS === 'web') {
        await displayNotification(displayPayload);
      } else {
        await displayNotificationWithTimer(displayPayload);
      }
      return;
    }

    await displayNotification(displayPayload);
    return;
  }
  // Case 2: Firebase notification payload
  else {
    const isForeground = AppState.currentState === 'active';

    if (isForeground) {
      const notificationTitle = message?.notification?.title ?? '';
      const notificationBody = message?.notification?.body ?? '';
      const imageUrl = message?.notification?.image;

      const campaignId = message?.data?.campaignId;
      const deeplinkingUrl = message?.data?.path;
      const sourceReferenceId = message?.data?.sourceReferenceId;
      const sourceReferenceType = message?.data?.sourceReferenceType;
      const showTimer = message?.data?.showTimer;
      const startTime = message?.data?.startTime;
      const endTime = message?.data?.endTime;
      const messageId = message?.messageId;

      console.log('message?.data?. ***', JSON.stringify(message?.data));

      const data: INotificationData = {
        campaignId,
        deeplinkingUrl,
        sourceReferenceId,
        sourceReferenceType,
        showTimer,
        startTime,
        endTime,
        messageId,
      };

      const displayPayload = {
        title: notificationTitle,
        body: notificationBody,
        imageUrl,
        data,
      };

      if (showTimer === 'true') {
        if (Platform.OS === 'web') {
          await displayNotification(displayPayload);
        } else {
          await displayNotificationWithTimer(displayPayload);
        }
        return;
      }

      await displayNotification(displayPayload);
      return;
    } else {
      // Background → Firebase already displayed → skip
      return;
    }
  }
};
